<form [formGroup]="contactDetailsForm" (ngSubmit)="onSubmit()">
  <gc-input-field
    formControlName="email"
    [errorMap]="{
      required: ('field_is_required' | translate),
      email: ('please_enter_a_valid_email_address' | translate),
    }"
    [error]="true"
    label="{{ 'email_address' | translate }}"
    required="true"
    [readonly]="editingUserAccount"
    (click)="changeEmail()"
  ></gc-input-field>
  <div class="contact-details">
    <div class="cell-phone" [class.full-width]="!editingUserAccount">
      <mat-form-field>
        <mat-label>{{ 'mobile_number' | translate }}</mat-label>
        <input matInput type="tel" autocomplete="mobile" formControlName="cellnr" gcInputMask="[0-9]" />
        <mat-error *ngIf="contactDetailsForm.get('cellnr').hasError('required')">{{ 'this_field_is_required' | translate }}</mat-error>
        <mat-error *ngIf="contactDetailsForm.get('cellnr').hasError('pattern')">
          {{ 'please_enter_a_valid_cellphone_number' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="verify-button" *ngIf="editingUserAccount">
      <button type="button" mat-raised-button color="primary" [disabled]="disableVerify" (click)="verifyMobile()">
        {{ mobileNumberVerified ? ('verified' | translate) : isOpen ? ('cancel' | translate) : ('verify' | translate) }}
      </button>
    </div>
  </div>
  <div *ngIf="editingUserAccount && isOpen" class="otp-card" [@openClose]="isOpen ? 'open' : 'closed'">
    <p class="otp-label">{{ 'please_enter_the_pin_sent_to_confirm_your_mobile_number' | translate }}</p>
    <mat-form-field>
      <mat-label>{{ 'one_time_pin_otp' | translate }}</mat-label>
      <input matInput type="text" name="otp" class="uppercase" autocomplete="one-time-pin" [formControl]="otpControl" maxlength="4" />
    </mat-form-field>
    <button class="resend-btn" type="button" mat-raised-button (click)="sendOtp()">
      <span>{{ 'resend_pin' | translate }}</span>
    </button>
  </div>
  <gc-input-field
    formControlName="homenr"
    [errorMap]="{ pattern: ('please_enter_a_valid_telephone_number' | translate) }"
    label="{{ 'home_number' | translate }}"
    [error]="true"
    gcNullOnEmpty
    gcInputMask="[0-9]"
  ></gc-input-field>
  <gc-input-field
    formControlName="worknr"
    [errorMap]="{ pattern: ('please_enter_a_valid_telephone_number' | translate) }"
    label="{{ 'work_number' | translate }}"
    [error]="true"
    gcNullOnEmpty
    gcInputMask="[0-9]"
  ></gc-input-field>
  <ng-container *ngIf="!editingDependant && contactDetailsForm.get('nok_name') && contactDetailsForm.get('nok_number')">
    <gc-input-field formControlName="nok_name" label="{{ 'next_of_kin' | translate }}" gcNullOnEmpty></gc-input-field>
    <gc-input-field
      formControlName="nok_number"
      label="{{ 'next_of_kin_contact_number' | translate }}"
      type="tel"
      errorMap="{{ 'please_enter_a_valid_telephone_number' | translate }}"
      gcNullOnEmpty
      gcInputMask="[0-9]"
    ></gc-input-field>
  </ng-container>
  <div class="submit-button-div" *ngIf="editingUserAccount">
    <button type="submit" mat-raised-button>
      <mat-icon svgIcon="content-save"></mat-icon>
      {{ mobileNumberVerified ? ('save_contact_details' | translate) : ('verify_your_mobile_number' | translate) }}
    </button>
  </div>
</form>
